import { render, staticRenderFns } from "./DataViewer.vue?vue&type=template&id=08ef501c&scoped=true"
import script from "./DataViewer.vue?vue&type=script&lang=ts"
export * from "./DataViewer.vue?vue&type=script&lang=ts"
import style0 from "./DataViewer.vue?vue&type=style&index=0&id=08ef501c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ef501c",
  null
  
)

export default component.exports